import React, { useState } from 'react';
import { SearchIcon, XIcon } from 'lucide-react';
export function EntityLookupModal({
  isOpen,
  onClose,
  onSelectEntity,
  entities
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedEntity, setSelectedEntity] = useState(null);
  // Filter entities based on search term
  const filteredEntities = entities.filter(entity => entity.name.toLowerCase().includes(searchTerm.toLowerCase()) || entity.code.toLowerCase().includes(searchTerm.toLowerCase()) || entity.description.toLowerCase().includes(searchTerm.toLowerCase()));
  // Handle entity selection
  const handleSelectEntity = entity => {
    setSelectedEntity(entity);
  };
  // Handle confirm selection
  const handleConfirmSelection = () => {
    if (selectedEntity) {
      onSelectEntity(selectedEntity);
    }
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center z-50" data-id="element-15429">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[80vh] flex flex-col" data-id="element-15430">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-15431">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-15432">Entity Lookup</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-15433">
            <XIcon className="h-5 w-5" data-id="element-15434" />
          </button>
        </div>
        {/* Search Bar */}
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-15435">
          <div className="relative rounded-md shadow-sm" data-id="element-15436">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-15437">
              <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-15438" />
            </div>
            <input type="text" className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md" placeholder="Search by entity name, code, or description" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-15439" />
          </div>
        </div>
        {/* Entity List */}
        <div className="flex-1 overflow-auto" data-id="element-15440">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-15441">
            <thead className="bg-gray-50" data-id="element-15442">
              <tr data-id="element-15443">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15444">
                  Entity Code
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15445">
                  Name
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15446">
                  Description
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15447">
                  Country
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15448">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-15449">
              {filteredEntities.length > 0 ? filteredEntities.map(entity => <tr key={entity.id} onClick={() => handleSelectEntity(entity)} className={`cursor-pointer hover:bg-gray-50 ${selectedEntity?.id === entity.id ? 'bg-indigo-50' : ''}`} data-id="element-15450">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-15451">
                      {entity.code}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-15452">
                      {entity.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-15453">
                      {entity.description}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-15454">
                      {entity.country}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-15455">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${entity.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-15456">
                        {entity.status}
                      </span>
                    </td>
                  </tr>) : <tr data-id="element-15457">
                  <td colSpan={5} className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-15458">
                    No entities found matching your search criteria
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end" data-id="element-15459">
          <button type="button" className="mr-3 px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={onClose} data-id="element-15460">
            Cancel
          </button>
          <button type="button" className="px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={handleConfirmSelection} disabled={!selectedEntity} data-id="element-15461">
            Select Entity
          </button>
        </div>
      </div>
    </div>;
}